export const CAMPAIGNID = process.env.REACT_APP_CAMPAIGNID
export const TENANTID = process.env.REACT_APP_TENANTID

export const START_DATE = process.env.REACT_APP_START_DATE_CAMPAIGN
export const END_DATE = process.env.REACT_APP_END_DATE_CAMPAIGN
export const LINK_VIDEO = 'https://www.youtube.com/embed/fnDWA25Wzqg'

export const TELCO = [
  {
    label: 'Viettel',
    value: 'Viettel',
  },
  {
    label: 'Vinaphone',
    value: 'Vinaphone',
  },
  {
    label: 'Mobiphone',
    value: 'Mobiphone',
  },

  {
    label: 'Vietnamobile',
    value: 'Vietnamobile',
  },
]

export const HOTLINE = 'Hotline <strong>1900 633 415</strong>'
export const ERROR_MSG = 'Đã có lỗi xảy ra. Bạn vui lòng thử lại sau.'
export const SHOW_POPUP_REDIRECT_LOGIN = 'SHOW_POPUP_REDIRECT_LOGIN'
export const WISHLISTS = [
  {
    obj: 'mom',
    description:
      'Mẹ à, \nCảm ơn mẹ vì đã luôn dịu dàng dành trọn tình yêu cho gia đình mình. Dẫu cho ít khi thong dong, mong món quà này sẽ là lời nhắc nhở để mẹ đừng quên nghỉ ngơi, chăm sóc bản thân mình nhiều hơn nhé.Thương mẹ!',
  },
  {
    obj: 'love',
    description: `Gửi người thương, \nCảm ơn em vì tất thảy ngọt ngào và dịu dàng suốt chặng đường vừa qua. Tặng em một chút nâng niu để hôm nay và cả những ngày sau bên nhau, em luôn biết mình được trân trọng và yêu thương thật nhiều. Love you!`,
  },
  {
    obj: 'friend',
    description: `Bạn thân ơi, \nThật may mắn vì qua đủ chuyện vui, buồn vẫn có bạn ở đây bên cạnh. Tặng bạn món quà “lấy vía” rạng rỡ để bạn mãi yêu đời, cười vui. Mong năm tháng phía trước cô gái của tui sẽ tỏa sáng và tự tin nha!`,
  },
  {
    obj: 'sister',
    description: `Chị yêu ơi, \nCảm ơn chị vì đã luôn là điểm tựa, là người đồng hành cùng em với thật nhiều thấu hiểu. Ai bảo làm chị thì không được nuông chiều? Tặng chị món quà nhỏ cho nụ cười chị luôn xinh đẹp, rạng rỡ. Mãi tự tin nhé chị ơi!`,
  },
  {
    obj: 'default',
    description: `Chào bạn,\n\nDịp cuối năm luôn đi kèm những bữa tiệc cùng bạn bè, người thân, nhìn lại chặng đường rực rỡ đã qua, đừng quên dùng P/S Bàn Chải Điện mỗi ngày để chăm răng sạch khỏe, tự tin cười tươi mọi khoảnh khắc nha\n\nChúc bạn 10X Rạng Rỡ\nKết Năm Rạng Ngời!`,
  },
]

export const LISTSONG = [
  {
    id: 1,
    link: 'https://qcstorage.utop.io/qc-evidence/PSLDP2024/Valentines.mp3',
  },
  {
    id: 2,
    link: 'https://qcstorage.utop.io/qc-evidence/PSLDP2024/Inspiration-piano.mp3',
  },
  {
    id: 3,
    link: 'https://qcstorage.utop.io/qc-evidence/PSLDP2024/Mellow-Background-full.mp3',
  },
  {
    id: 4,
    link: 'https://qcstorage.utop.io/qc-evidence/PSLDP2024/Simple-Cute-Piano.mp3',
  },
  {
    id: 5,
    link: 'https://qcstorage.utop.io/qc-evidence/PSLDP2024/love-story-full.mp3',
  },
]

export const frameList = [
  {
    id: 'f1',
    name: 'card-whish.png',
  },
  {
    id: 'f2',
    name: 'card-whish-2.png',
  },
  {
    id: 'f3',
    name: 'card-whish-3.png',
  },
  {
    id: 'f4',
    name: 'card-whish-4.png',
  },
]

export const ERROR_CODE = {
  CAMPAIGN_NOT_STARTED: 'CampaignNotStarted',
  CAMPAIGN_ENDED: 'CampaignEnded',
  TRANSACTION_NOT_FOUND: 'TransactionNotFound',
  INVALID_PHONE_NUMBER: 'InValidPhoneNumber',
  EXCEEDED_REGISTRATION_LIMIT: 'ExceededRegistrationLimit',
  INVALID_RESEND_TIME: 'InvalidResendTime',
  VERIFY_OTP_FAIL: 'VerifyOTPFail',
}

export const APP_MESSAGE = {
  CAMPAIGN_NOT_STARTED: 'Chương trình chưa bắt đầu, vui lòng quay trở lại vào ngày 13/03/2025',
  CAMPAIGN_ENDED: 'Chương trình đã kết thúc, hẹn gặp bạn ở chương trình lần sau nhé',
  TRANSACTION_NOT_FOUND: '',
  INVALID_PHONE_NUMBER: 'Số điện thoại không hợp lệ, vui lòng kiểm tra lại',
  EXCEEDED_REGISTRATION_LIMIT: 'Bạn đã nhận báo cáo kiểm tra răng miệng trước đó. Cám ơn bạn đã tham gia chương trình.',
  INVALID_RESEND_TIME: 'Yêu cầu gửi mã OTP của bạn đang được chúng tôi xử lý, bạn hãy thử lại sau 1 phút nhé',
  VERIFY_OTP_FAIL: 'Mã xác thực chưa chính xác. Vui lòng kiểm tra lại thông tin',
  VERIFY_OTP_TIMEOUT: 'Mã xác thực đã hết hạn. Vui lòng gửi lại mã mới và thử lại',
  ERROR_COMMON: 'Đã xảy ra lỗi khi kết nối đến hệ thống. Vui lòng thử lại sau',
  JOIN_SUCCESS: 'P/S đã gửi báo cáo qua tin nhắn sms, vui lòng kiểm tra điện thoại của quý khách!',
}

export const CLICK_ACTION_POPUP_MESSAGE = 'CLICK_ACTION_POPUP_MESSAGE'
export const CLICK_ACTION_1_POPUP_MESSAGE = 'CLICK_ACTION_1_POPUP_MESSAGE'
export const CLICK_ACTION_2_POPUP_MESSAGE = 'CLICK_ACTION_2_POPUP_MESSAGE'

export const ALLOW_PHONE_LIST = [
  '032',
  '033',
  '034',
  '035',
  '036',
  '037',
  '038',
  '039',
  '052',
  '055',
  '056',
  '058',
  '059',
  '070',
  '076',
  '077',
  '078',
  '079',
  '081',
  '082',
  '083',
  '084',
  '085',
  '086',
  '087',
  '088',
  '089',
  '090',
  '091',
  '092',
  '093',
  '094',
  '096',
  '097',
  '098',
  '099',
  '0777',
]
